import { useState } from 'react';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import { toast } from 'react-hot-toast';
import { sendTestEmail } from '../../lib/sendTestEmail';

interface EmailTestButtonProps {
  recipientEmail: string;
}

export default function EmailTestButton({ recipientEmail }: EmailTestButtonProps) {
  const [isSending, setIsSending] = useState(false);

  const handleSendTestEmail = async () => {
    if (!recipientEmail) {
      toast.error('Please enter a valid email address');
      return;
    }

    try {
      setIsSending(true);
      const success = await sendTestEmail(recipientEmail);
      
      if (success) {
        toast.success(`Test email sent to ${recipientEmail}`);
      } else {
        toast.error('Failed to send test email. Check console for details.');
      }
    } catch (error) {
      console.error('Error sending test email:', error);
      toast.error('An error occurred while sending the test email');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <button
      onClick={handleSendTestEmail}
      disabled={isSending || !recipientEmail}
      className="px-4 py-2 bg-golf-orange text-white font-medium rounded-lg hover:bg-golf-orange/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
    >
      <EnvelopeIcon className="w-5 h-5" />
      {isSending ? 'Sending...' : 'Send Test Email'}
    </button>
  );
}